import { Columns } from '#types/grid';

export const columnDefinition: Columns = [
  {
    key: 'carrier.carrier_lookup_dialog.grid.columns.carrier',
    field: 'carrier',
    width: 85,
    sort: 'asc',
    sortOrder: 1,
  },
  {
    key: 'carrier.carrier_lookup_dialog.grid.columns.name',
    field: 'name',
    width: 180,
  },
  {
    key: 'carrier.carrier_lookup_dialog.grid.columns.contact',
    field: 'contact',
    width: 150,
  },
  {
    key: 'carrier.carrier_lookup_dialog.grid.columns.phone',
    field: 'phone',
    width: 150,
  },
  {
    key: 'carrier.carrier_lookup_dialog.grid.columns.statusabbrev',
    field: 'statusabbrev',
    width: 80,
  },
  {
    key: 'carrier.carrier_lookup_dialog.grid.columns.state',
    field: 'state',
    width: 80,
  },
  {
    key: 'carrier.carrier_lookup_dialog.grid.columns.scac',
    field: 'scac',
    width: 70,
  },
  {
    key: 'carrier.carrier_lookup_dialog.grid.columns.minpronocount',
    field: 'minpronocount',
    width: 80,
    formatter: 'number',
    align: 'right',
    sortable: false,
  },
  {
    key: 'carrier.carrier_lookup_dialog.grid.columns.unusedpronocount',
    field: 'unusedpronocount',
    width: 80,
    formatter: 'number',
    align: 'right',
  },
  {
    key: 'carrier.carrier_lookup_dialog.grid.columns.small_package_carrier',
    field: 'small_package_carrier',
    width: 80,
    formatter: 'yn',
  },
  {
    key: 'carrier.carrier_lookup_dialog.grid.columns.multiship',
    field: 'multiship',
    width: 90,
    formatter: 'yn',
  },

  // hidden columns
  {
    key: 'carrier.carrier_lookup_dialog.grid.columns.carrierstatus',
    field: 'carrierstatus',
    width: 80,
    visible: false,
    canToggleVisibility: false,
  },
  {
    key: 'carrier.carrier_lookup_dialog.grid.columns.addr1',
    field: 'addr1',
    width: 80,
    visible: false,
    canToggleVisibility: false,
  },
  {
    key: 'carrier.carrier_lookup_dialog.grid.columns.addr2',
    field: 'addr2',
    width: 80,
    visible: false,
    canToggleVisibility: false,
  },
  {
    key: 'carrier.carrier_lookup_dialog.grid.columns.city',
    field: 'city',
    width: 80,
    visible: false,
    canToggleVisibility: false,
  },

  {
    key: 'carrier.carrier_lookup_dialog.grid.columns.postalcode',
    field: 'postalcode',
    width: 80,
    visible: false,
    canToggleVisibility: false,
  },
  {
    key: 'carrier.carrier_lookup_dialog.grid.columns.countrycode',
    field: 'countrycode',
    width: 80,
    visible: false,
    canToggleVisibility: false,
  },
  {
    key: 'carrier.carrier_lookup_dialog.grid.columns.fax',
    field: 'fax',
    width: 80,
    visible: false,
    canToggleVisibility: false,
  },
  {
    key: 'carrier.carrier_lookup_dialog.grid.columns.email',
    field: 'email',
    width: 80,
    visible: false,
    canToggleVisibility: false,
  },
  {
    key: 'carrier.carrier_lookup_dialog.grid.columns.lastuser',
    field: 'lastuser',
    width: 80,
    visible: false,
    canToggleVisibility: false,
  },
  {
    key: 'carrier.carrier_lookup_dialog.grid.columns.lastupdate',
    field: 'lastupdate',
    width: 80,
    visible: false,
    canToggleVisibility: false,
  },
  {
    key: 'carrier.carrier_lookup_dialog.grid.columns.carrier_rowid',
    field: 'carrier_rowid',
    width: 80,
    visible: false,
    canToggleVisibility: false,
  },
];
